import { extractImageFrames, clampTo, resolveVideoSize } from '../../tools';
import type { AlibabaModelConfig } from '../types';

export const wanConfigs: Record<string, AlibabaModelConfig> = {
    'wan-2.7': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.8466032.console-base_product-drawer-right.dproducts-and-services-sfm.542c1450OGxie0&tab=api#/api/?type=model&url=2865250
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.8466032.console-base_product-drawer-right.dproducts-and-services-sfm.542c1450OGxie0&tab=api#/api/?type=model&url=3025059
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.8466032.console-base_product-drawer-right.dproducts-and-services-sfm.542c1450OGxie0&tab=api#/api/?type=model&url=3001146
        apiPath: '/api/v1/services/aigc/video-generation/video-synthesis',
        pollApiPath: '/api/v1/tasks/${requestId}',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, duration, aspectRatio, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            const images = (imagePrompt ?? []).filter(Boolean).slice(0, 9);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'wan2.7-i2v-2026-04-25',
                    input: {
                        prompt: prompt.slice(0, 5000),
                        negative_prompt: typeof (providerOptions as any)?.negative_prompt === 'string' ? (providerOptions as any).negative_prompt : undefined,
                        media: [
                            {
                                type: 'first_frame',
                                url: firstImage,
                            }
                        ],
                    },
                    parameters: {
                        resolution: clampTo((quality || '720P').toUpperCase(), ['720P', '1080P'] as const, '720P'),
                        duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        seed: typeof (providerOptions as any)?.seed === 'number' ? (providerOptions as any).seed : undefined,
                        // 可选参数
                        prompt_extend: typeof (providerOptions as any)?.prompt_extend === 'boolean' ? (providerOptions as any).prompt_extend : false,
                        watermark: typeof (providerOptions as any)?.watermark === 'boolean' ? (providerOptions as any).watermark : false,
                    },
                };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                return {
                    model: 'wan2.7-i2v-2026-04-25',
                    input: {
                        prompt: prompt.slice(0, 5000),
                        negative_prompt: typeof (providerOptions as any)?.negative_prompt === 'string' ? (providerOptions as any).negative_prompt : undefined,
                        media: [
                            {
                                type: 'first_frame',
                                url: firstImage,
                            },
                            {
                                type: 'last_frame',
                                url: lastImage,
                            }
                        ],
                    },
                    parameters: {
                        resolution: clampTo((quality || '720P').toUpperCase(), ['720P', '1080P'] as const, '720P'),
                        duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        seed: typeof (providerOptions as any)?.seed === 'number' ? (providerOptions as any).seed : undefined,
                        // 可选参数
                        prompt_extend: typeof (providerOptions as any)?.prompt_extend === 'boolean' ? (providerOptions as any).prompt_extend : false,
                        watermark: typeof (providerOptions as any)?.watermark === 'boolean' ? (providerOptions as any).watermark : false,
                    },
                };
            // 参考模式
            } else if (frameMode === 'ref') {
                return {
                    model: 'wan2.7-r2v',
                    input: {
                        prompt: prompt.slice(0, 5000),
                        media: [
                            ...images.map(url => ({
                                type: "reference_image",
                                url: url
                            })),
                        ],
                    },
                    parameters: {
                        ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'),
                        resolution: clampTo((quality || '720P').toUpperCase(), ['720P', '1080P'] as const, '720P'),
                        duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        seed: typeof (providerOptions as any)?.seed === 'number' ? (providerOptions as any).seed : undefined,
                        // 可选参数
                        prompt_extend: typeof (providerOptions as any)?.prompt_extend === 'boolean' ? (providerOptions as any).prompt_extend : false,
                        watermark: typeof (providerOptions as any)?.watermark === 'boolean' ? (providerOptions as any).watermark : false,
                    },
                };
            // 文生视频模式
            } else {
                return {
                    model: 'wan2.7-t2v-2026-04-25',
                    input: {
                        prompt: prompt.slice(0, 5000),
                        negative_prompt: typeof (providerOptions as any)?.negative_prompt === 'string' ? (providerOptions as any).negative_prompt : undefined,
                        audio: undefined,
                    },
                    parameters: {
                        ratio: clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '4:5', '5:4', '4:3', '3:4', '1:1'] as const, '16:9'),
                        resolution: clampTo((quality || '720P').toUpperCase(), ['720P', '1080P'] as const, '720P'),
                        duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        seed: typeof (providerOptions as any)?.seed === 'number' ? (providerOptions as any).seed : undefined,
                        // 可选参数
                        prompt_extend: typeof (providerOptions as any)?.prompt_extend === 'boolean' ? (providerOptions as any).prompt_extend : false,
                        watermark: typeof (providerOptions as any)?.watermark === 'boolean' ? (providerOptions as any).watermark : false,
                    },
                };
            }
        },
    },
    'wan-2.7-v2v': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.8466032.console-base_product-drawer-right.dproducts-and-services-sfm.542c1450OGxie0&tab=api#/api/?type=model&url=3021842
        apiPath: '/api/v1/services/aigc/video-generation/video-synthesis',
        pollApiPath: '/api/v1/tasks/${requestId}',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, videoUri, duration, aspectRatio, quality, providerOptions } = params;
            const images = (imagePrompt ?? []).filter(Boolean).slice(0, 9);
            // 视频编辑模式
            return {
                model: 'wan2.7-videoedit',
                input: {
                    prompt: prompt.slice(0, 5000),
                    negative_prompt: typeof (providerOptions as any)?.negative_prompt === 'string' ? (providerOptions as any).negative_prompt : undefined,
                    media: [
                        {
                            type: 'video',
                            url: videoUri,
                        },
                        ...images.map(url => ({
                            type: 'reference_image',
                            url: url,
                        })),
                    ],
                },
                parameters: {
                    resolution: clampTo(quality || '720P', ['720P', '1080P'] as const, '720P'),
                    ratio: clampTo(aspectRatio || '16:9', ['16:9', '4:3', '1:1', '3:4', '9:16'] as const, '16:9'),
                    duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10] as const, 5),
                    seed: typeof (providerOptions as any)?.seed === 'number' ? (providerOptions as any).seed : undefined,
                    // 可选参数
                    audio_setting: typeof (providerOptions as any)?.audio_setting === 'string' ? (providerOptions as any).audio_setting : 'auto',
                    prompt_extend: typeof (providerOptions as any)?.prompt_extend === 'boolean' ? (providerOptions as any).prompt_extend : false,
                    watermark: typeof (providerOptions as any)?.watermark === 'boolean' ? (providerOptions as any).watermark : false,
                },
            };
        },
    },
    'wan-2.6-flash': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.8466032.console-base_product-drawer-right.dproducts-and-services-sfm.542c1450OGxie0&tab=api#/api/?type=model&url=2867393
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.8466032.console-base_product-drawer-right.dproducts-and-services-sfm.542c1450OGxie0&tab=api#/api/?type=model&url=3030512
        apiPath: '/api/v1/services/aigc/video-generation/video-synthesis',
        pollApiPath: '/api/v1/tasks/${requestId}',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, duration, aspectRatio, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage] = extractImageFrames(imagePrompt);
            const images = (imagePrompt ?? []).filter(Boolean).slice(0, 9);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'wan2.6-i2v-flash',
                    input: {
                        prompt: prompt.slice(0, 1500),
                        negative_prompt: typeof (providerOptions as any)?.negative_prompt === 'string' ? (providerOptions as any).negative_prompt : undefined,
                        img_url: firstImage,
                        audio_url: undefined,
                        template: undefined,
                    },
                    parameters: {
                        resolution: clampTo((quality || '720P').toUpperCase(), ['720P', '1080P'] as const, '720P'),
                        duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        seed: typeof (providerOptions as any)?.seed === 'number' ? (providerOptions as any).seed : undefined,
                        // 可选参数
                        audio: typeof (providerOptions as any)?.audio === 'boolean' ? (providerOptions as any).audio : true,
                        prompt_extend: typeof (providerOptions as any)?.prompt_extend === 'boolean' ? (providerOptions as any).prompt_extend : false,
                        shot_type: typeof (providerOptions as any)?.shot_type === 'string' ? (providerOptions as any).shot_type : 'multi',
                        watermark: typeof (providerOptions as any)?.watermark === 'boolean' ? (providerOptions as any).watermark : false,
                    },
                };
            // 参考模式
            } else {
                return {
                    model: 'wan2.6-r2v-flash',
                    input: {
                        prompt: prompt.slice(0, 1500),
                        negative_prompt: typeof (providerOptions as any)?.negative_prompt === 'string' ? (providerOptions as any).negative_prompt : undefined,
                        reference_urls: images.slice(0, 5),
                    },
                    parameters: {
                        size: resolveVideoSize(clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'), clampTo(quality || '720P', ['720P', '1080P'] as const, '720P')),
                        duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10] as const, 5),
                        seed: typeof (providerOptions as any)?.seed === 'number' ? (providerOptions as any).seed : undefined,
                        // 可选参数
                        audio: typeof (providerOptions as any)?.audio === 'boolean' ? (providerOptions as any).audio : false,
                        shot_type: typeof (providerOptions as any)?.shot_type === 'string' ? (providerOptions as any).shot_type : 'multi',
                        watermark: typeof (providerOptions as any)?.watermark === 'boolean' ? (providerOptions as any).watermark : false,
                    },
                }
            }
        },
    },
};